/** Feedback visuel drag & drop — ne change pas l’algorithme `moveItemInList`. */

export function dropEdgeFromEvent(event) {
  const rect = event.currentTarget.getBoundingClientRect();
  if (!rect.height) return 'after';
  return event.clientY < rect.top + rect.height / 2 ? 'before' : 'after';
}

/**
 * Id cible de `moveItemInList` pour insérer avant / après l’élément survolé.
 */
export function resolveReorderTargetId(list, dragId, hoverId, edge) {
  if (!dragId || !hoverId || !list?.length) return hoverId;
  const fromIdx = list.findIndex((item) => item.id === dragId);
  const hoverIdx = list.findIndex((item) => item.id === hoverId);
  if (fromIdx < 0 || hoverIdx < 0) return hoverId;
  if (edge === 'before') {
    if (fromIdx < hoverIdx) return list[hoverIdx - 1]?.id || hoverId;
    return hoverId;
  }
  if (fromIdx > hoverIdx) return list[hoverIdx + 1]?.id || hoverId;
  return hoverId;
}
